import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { io } from 'socket.io-client';
import axiosInstance from '../../../config/axiosInstance';

const queryClient = new QueryClient();
export default function ChatScreen() {
	return (
		<QueryClientProvider client={queryClient}>
			<ChatComponent />
		</QueryClientProvider>
	);
}

export const ChatComponent = () => {
	const [messages, setMessages] = useState<any[]>([]);
	const [email, setEmail] = useState<any[]>([]);

	const socket = io(
		'https://b3uvhz8r1f.execute-api.us-east-2.amazonaws.com/v3',
		{ transports: ['websocket', 'polling', 'flashsocket'] }
	);

	async function fetchConversations() {
		const { data } = await axiosInstance().get(
			'https://b3uvhz8r1f.execute-api.us-east-2.amazonaws.com/v3/api/chat'
		);
		return data;
	}

	const { data, isFetching, isLoading, isError } = useQuery(
		[],
		() => fetchConversations(),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	useEffect(() => {
		console.log(data);
		if (data != null)
			data.forEach((el: any) => {
				const messagesCopy: any[] = messages.slice();
				messagesCopy.push(el);
				setMessages(messagesCopy);
			});
	}, [data]);

	const handleSubmit = (message: any) => {
		socket.emit('sendMessage', message);
	};

	//Listen to recMessage event to get the messages sent by users

	useEffect(() => {
		console.log('yoo2');
		socket.on('recMessage', (message: any) => {
			console.log('yoo3', messages);
			const messagesCopy: any[] = messages.slice();
			messagesCopy.push(message);
			setMessages(messagesCopy);
		});
	}, []);

	return (
		<body>
			<nav className="navbar navbar-light bg-light">
				<div className="container-fluid">
					<a className="navbar-brand">Lets Chat</a>
				</div>
			</nav>
			<div className="">
				<div className="flex h-full">
					<ul className="flex flex-col">
						{messages.map((message) => (
							<div>
								<li className="bg-secondary p-2 rounded mb-2 text-light">
									<span>{message.email}</span>
									{message.text}
								</li>
							</div>
						))}
					</ul>
				</div>
				<div className="mb-3 mt-4">
					<input
						className="form-control"
						id="email"
						placeholder="Your Email"
						onBlur={(e: any) => setEmail(e.target.value)}
					/>
				</div>
				<div className="mb-3 mt-4">
					<input
						className="form-control"
						id="exampleFormControlTextarea1"
						placeholder="Say something..."
						onKeyDown={(e: any) => {
							if (e.keyCode === 13) {
								handleSubmit({ email: email, text: e.target.value });
								e.target.value = '';
							}
						}}
					/>
				</div>
			</div>
		</body>
	);
};
